import "./AllBlogs.css";
import React, { useContext, useEffect } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import blogsContext from "../../context/blogs/blogscontext";
import progressContext from "../../context/loading/progresscontext";
import Breadcrumb from "../Breadcrumb/Breadcrumb";
import CtaBand from "../home/ctaband/CtaBand";

function AllBlogs() {
  const { setProgress } = useContext(progressContext);
  const { blogs } = useContext(blogsContext);
  const location = useLocation();
  const navigate = useNavigate();

  const searchParams = new URLSearchParams(location.search);
  const currentPage = parseInt(searchParams.get("page")) || 1;

  const blogsPerPage = 6;
  const sortedBlogs = blogs && blogs.length ? [...blogs].sort(
    (a, b) => new Date(b.publishedAt) - new Date(a.publishedAt)
  ) : [];

  const totalPages = Math.ceil(sortedBlogs.length / blogsPerPage) || 1;
  const startIndex = (currentPage - 1) * blogsPerPage;
  const currentBlogs = sortedBlogs.slice(startIndex, startIndex + blogsPerPage);

  useEffect(() => {
    if (setProgress) {
      setProgress(70);
      setTimeout(() => setProgress(100), 100);
    }
  }, [setProgress]);

  const handlePageChange = (newPage) => {
    if (newPage >= 1 && newPage <= totalPages) {
      navigate(`/blogs?page=${newPage}`);
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  };

  return (
    <main className="blogs-page">
      <Breadcrumb
        pageName="Medical Insights &amp; Articles"
        bgImage="/img/uplaods/rad.jpg"
        path={[
          { label: "Home", href: "/" },
          { label: "Articles" },
        ]}
      />

      <section className="band">
        <div className="wrap">
          <p className="eyebrow">Health &amp; Wellness</p>
          <h2 className="h-sec">Insights from our doctors.</h2>
          <p className="lede" style={{ marginTop: '16px' }}>
            Practical, plain-language guidance on pregnancy, maternal health, newborn care, and women's wellness from the medical team in Malleswaram.
          </p>

          <div className="blogs-grid">
            {currentBlogs.map((item) => (
              <article className="blog-item-card" key={item.id || item.url}>
                <div className="blog-item-img">
                  <img
                    src={`/img/uplaods/${item.imgSrc}`}
                    alt={item.title}
                    loading="lazy"
                    onError={(e) => {
                      e.target.onerror = null;
                      e.target.src = "/img/uplaods/rad.jpg";
                    }}
                  />
                </div>
                <div className="blog-item-content">
                  <span className="blog-item-date">
                    {item.publishedAt ? new Date(item.publishedAt).toLocaleDateString("en-GB", { day: 'numeric', month: 'short', year: 'numeric' }) : 'Clinical Insight'}
                  </span>
                  <h3 className="blog-item-title">
                    <Link to={`/blogs/${item.url}`}>{item.title}</Link>
                  </h3>
                  <p className="blog-item-excerpt">
                    {item.content ? item.content.replace(/<[^>]*>?/gm, '') : (item.title2 || item.title)}
                  </p>
                  <Link to={`/blogs/${item.url}`} className="blog-item-more">
                    Read full article &rarr;
                  </Link>
                </div>
              </article>
            ))}
          </div>

          {totalPages > 1 && (
            <div className="blog-pagination">
              <button
                className="pagination-btn"
                onClick={() => handlePageChange(currentPage - 1)}
                disabled={currentPage === 1}
              >
                &larr; Previous
              </button>
              <span style={{ fontSize: '14px', color: 'var(--muted)' }}>
                Page {currentPage} of {totalPages}
              </span>
              <button
                className="pagination-btn"
                onClick={() => handlePageChange(currentPage + 1)}
                disabled={currentPage === totalPages}
              >
                Next &rarr;
              </button>
            </div>
          )}
        </div>
      </section>

      <CtaBand />
    </main>
  );
}

export default AllBlogs;

